import React from 'react'
import SAISVG from '../../../../../_template/helpers/CommonFunction'
import {getShortForm} from '../../../../component/common/Helper';
import CredentialPopup from '../../../../component/common/CredentialPopup';
const SetBotHtml = (props) => {
    const {bot_name} = props;
    return(
        <>
            <span className="me-2">
                <div className="badge badge-light-primary fw-bold mb-1">
                    {bot_name}
                </div>
            </span>
        </>
    )
}
const SetChannelHtml = (props) => {
    const {channel_name} = props;
    return(
        <>
            <div className="badge badge-light-dark fw-bold">
                {channel_name}
            </div>
        </>
    )
}

const AgentListTable = (props) => {
    const {
        agent_full_name, 
        agent_email, 
        password , 
        username, 
        active_status,
        bot_data,
        channel_data,
        unique_id
    } = props;

    // ------------------- set product -------------- //
    let botHtml = bot_data?.map(bot => (
        <SetBotHtml
            key={bot.id || bot.bot_name}
            bot_name={bot.bot_name}
        />
    )) || '';
    // ------------- set channel ------------- //
    let channelHtml = channel_data?.map(channel => (
        <SetChannelHtml
            key={channel.id || channel.channel_name}
            channel_name={channel.channel_name}
        />
    )) || '';

    return (
        <>
            <tr className="">
                <td className="d-flex align-items-center border-none">
                    <div className="symbol rounded symbol-50px overflow-hidden me-3">
                        <a>
                            <div className="symbol-label fs-3 bg-light-dark text-dark fw-bold text-uppercase">
                                {getShortForm(agent_full_name)} 
                            </div>
                        </a>
                    </div>
                    <div className="d-flex flex-column">
                        <a className="text-gray-800  mb-1">
                            {agent_full_name}
                        </a>
                        <span>
                            <div className="badge badge-light-dark fw-bold">
                                {agent_email}
                            </div>
                        </span>
                    </div>
                </td>
                <td>
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="d-flex justify-content-start flex-column">
                                <a className="text-gray-600 fw-bold fs-6">
                                    Last chat on
                                </a>
                                <span className="text-gray-800 fw-semibold d-block fs-7">
                                    27 Nov 2024 10:07
                                </span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="d-flex justify-content-start flex-column">
                                <a className="text-gray-600 fw-bold fs-6">
                                    Today session
                                </a>
                                <span className="text-gray-800 fw-semibold d-block fs-7">
                                    12
                                </span>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    {botHtml}
                </td>
                <td>
                    {channelHtml}
                </td>
                <td>
                    <div className="d-flex mb-4 float-end">
                        <div className="form-check form-switch m-auto">
                            <input 
                                className="form-check-input" 
                                type="checkbox" 
                                value="" 
                                defaultChecked={active_status === 'Y' ? true : false}
                                onChange={(event) => {
                                    const isChecked = event.target.checked;
                                    props.statusOnChange(username, isChecked);
                                }}
                            />
                        </div>
                        <a 
                            className="btn btn-sm btn-icon btn-light-dark me-3 px-4"
                            data-sai-menu-trigger='click'
                            data-sai-menu-placement='bottom-end'
                            data-sai-menu-flip='top-end'
                        >
                            <SAISVG path="media/icons/duotune/arrows/arr016.svg" className="svg-icon-muted svg-icon-2" />
                        </a>
                        <CredentialPopup
                            title='Agent Credential'
                            username={username}
                            password={atob(password)}
                        />

                        <button className="btn btn-sm btn-icon btn-light-primary me-3 px-4"
                            onClick={ () => props.agentUpdateOnClick(unique_id)}
                        >
                            <SAISVG path="media/icons/duotune/art/art005.svg" className="svg-icon-muted svg-icon-2" />
                        </button>
                        <button className="btn btn-sm btn-icon btn-light-danger px-4"
                            onClick={(e) => { e.preventDefault(); props.agentDeleteOnClick({
                                type: 'Y',
                                unique_id : unique_id,
                                user_name : username
                            }) }}
                        > 
                            <SAISVG path="media/icons/duotune/general/gen027.svg" className="svg-icon-muted svg-icon-2" />
                        </button>
                    </div>
                </td>
            </tr>
        </>
    )
}

export default AgentListTable